module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/blog-banner-1-600.927790e00d9aff71.jpg"+" 600w"+","+"https://static.sniffspot.com/packs/img/blog-banner-1-900.e55f6e25afcfcf29.jpg"+" 900w",
        images: [{path: "https://static.sniffspot.com/packs/img/blog-banner-1-600.927790e00d9aff71.jpg",width: 600,height: 281},{path: "https://static.sniffspot.com/packs/img/blog-banner-1-900.e55f6e25afcfcf29.jpg",width: 900,height: 422}],
        src: "https://static.sniffspot.com/packs/img/blog-banner-1-900.e55f6e25afcfcf29.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/blog-banner-1-900.e55f6e25afcfcf29.jpg"},
        
        width: 900,
        height: 422
      }